import React from 'react'

export function LoadingSpinner() {
  return <i className={'material-icons animate-rotating'}>refresh</i>;
}
